import { axiosWdw, domainEndpoint } from './axios';

const endpoint_thought = '/thought/';
const endpoint_feedback_response = '/feedback_response';

export default {
  get(thoughtid: number, params: any) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint_thought + thoughtid + endpoint_feedback_response,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  getForUser(thoughtid: number, userid: number) {
    return this.get(thoughtid, {
      rows: 1,
      page: 1,
      userid: userid,
      fields: 'id,feedbackid,attributes',
    });
  },

  put(feedback_response_id: number, thoughtid: number, data: object) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));

      axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint_thought + thoughtid + endpoint_feedback_response + '/' + feedback_response_id,
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  post(thoughtid: number, data: object) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(data));

      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint_thought + thoughtid + endpoint_feedback_response,
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            console.log('error');
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
